import React from 'react';

export const PageHeader = ({ title, subtitle, actions }) => {
  return (
    <div className="mb-8">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-gray-800">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg text-muted-foreground mt-2">{subtitle}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>
    </div>
  );
};